export const REASON_FIELD_NAME = 'reason';
export const REASON_MAX_LENGTH = 1000;
